import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { Object as Objekt } from 'graphql/models/generated';
import { DataTableResourceType } from 'models/data.model';
import { OfferBase } from 'models/offer.model';
import { OfferService } from 'shared/services/offer.service';
import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-objekt-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class ObjektSearchComponent {
  readonly resourceType: DataTableResourceType = 'Object';

  offer!: OfferBase;

  objectId = '';

  object?: Objekt;

  selectedItem!: Objekt;

  isDealer = false;

  constructor(
    private offerService: OfferService,
    private storeService: StoreService
  ) {}

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.storeService.getCurrentOffer().subscribe((offer) => {
      this.offer = offer;

      this.objectId = offer.objectId || '';
    });

    this.storeService.getOfferObject().subscribe((obj) => {
      this.object = obj;
    });

    this.storeService.isCurrentAccountDealer().subscribe((val) => {
      this.isDealer = val;
    });
  }

  onSubmit(): Observable<Objekt> {
    if (this.objectId && this.objectId === this.selectedItem.id) {
      return of(this.selectedItem);
    }
    // return selected, because Quote returns empty string
    return this.offerService.updateOfferWithObjekt(this.offer, this.selectedItem, this.isDealer).pipe(
      map(() => this.selectedItem),
      tap((item: Objekt) => this.storeService.setCurrentDataItem(item))
    );
  }

  onItemSelected(item: Objekt): void {
    this.selectedItem = item;
  }
}
